// extracted by mini-css-extract-plugin
export default {"Github":"GtihubStat_Github__BOPJ+","Github1":"GtihubStat_Github1__qozzQ"};